export const brand = {
  name: '[INSERT BRAND NAME]',
  tagline: 'Your AI Coach for Continuous Growth',
  supportEmail: 'support@example.com',
  salesEmail: 'sales@example.com',
  currency: 'AED',
  colours: {
    primary: '#071a33',
    secondary: '#0f8b8d',
    accent: '#c7953e'
  }
};

export const statusLabels = {
  pending_payment: 'Pending Payment',
  payment_successful: 'Payment Successful',
  awaiting_licence: 'Awaiting Licence Allocation',
  active: 'Active',
  payment_failed: 'Payment Failed',
  past_due: 'Past Due',
  cancelled: 'Cancelled',
  suspended: 'Suspended',
  expired: 'Expired',
  refunded: 'Refunded'
};